/* eslint-disable no-param-reassign */
import axios from 'axios';

import { apiUrl } from 'settings';

export const token = 'FreshStart_2020!!!';

export const api = axios.create({
  baseURL: apiUrl,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
